export const useIubenda = () => {
  const route = useRoute();

  const cookiePolicyId = {
    it: "37559117",
    en: "51771646",
    fr: "77596532",
    de: "42278443",
    es: "35687818",
    us: "48467840",
    ru: "79906284",
  };

  function getLocale() {
    if (route.params.locale == "en") {
      return route.params.country == "us"
        ? {
            lang: "en-US",
            id: cookiePolicyId.us,
          }
        : {
            lang: "en-GB",
            id: cookiePolicyId.en,
          };
    } else if (route.params.locale == "zh") {
      return {
        lang: "en-GB",
        id: cookiePolicyId.en,
      };
    }

    return {
      lang: route.params.locale,
      id: cookiePolicyId[route.params.locale],
    };
  }

  function getConfigs() {
    const locale = getLocale();
    return `
      var _iub = _iub || [];
      _iub.csConfiguration = {
        "askConsentAtCookiePolicyUpdate":true,
        "countryDetection":true,
        "enableLgpd":true,
        "enableUspr":true,
        "lgpdAppliesGlobally":false,
        "perPurposeConsent":true,
        "preferenceCookie":{
          "expireAfter":180
        },
        "siteId":2298250,
        "whitelabel":false,
        "cookiePolicyId":${locale.id},
        "lang":"${locale.lang || "it"}",
        "banner":{
          "acceptButtonCaptionColor":"white",
          "acceptButtonColor":"#23201A",
          "acceptButtonDisplay":true,
          "backgroundColor":"#FFFFFF",
          "brandBackgroundColor":"#FFFFFF",
          "brandTextColor":"#23201A",
          "closeButtonRejects":true,
          "customizeButtonCaptionColor":"#FFFFFF",
          "customizeButtonColor":"#666666",
          "customizeButtonDisplay":true,
          "explicitWithdrawal":true,
          "listPurposes":true,
          "logo":"data:image/svg+xml;base64,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",
          "position":"float-bottom-center",
          "rejectButtonCaptionColor":"white",
          "rejectButtonColor":"#23201A",
          "rejectButtonDisplay":true,
          "showPurposesToggles":true,
          "textColor":"#303030"
        }
      };
    `;
  }

  function openCookieSolutionBanner() {
    const iubendaPreferencesLink = document.querySelector(
      ".iubenda-cs-preferences-link"
    );
    if (iubendaPreferencesLink) {
      iubendaPreferencesLink.click();
    }
  }

  return {
    getLocale,
    getConfigs,
    openCookieSolutionBanner,
  };
};
